<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'手机号'">
              <a-input
                :placeholder="$t('enter') + ' 手机号' "
                v-model='queryParam.mobileNo' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'盘号'">
              <a-select style='width: 190px' allowClear v-model='queryParam.appSsid' @change='panhaoChange'>
                <a-select-option v-for='item in selectedList' :value='item.appssid' :key='item.appName'>{{ item.appName
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='handleDetail' icon='edit' style='margin-left: 8px'>{{ $t('edit')
                }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
        <template slot='noticeTitle2' slot-scope='text, record'>
          <div v-if="record.left.indexOf('身份证反面') === 0">
            <img v-if='showsmallimg' style='width: 150px' :src='record.right' @click='previewImage(record.right)' />
            <img v-if='showbigimg' style='width: 550px' :src='record.right' @click='closepreviewImage(record.right)'>
          </div>
          <div v-if="record.left.indexOf('身份证正面') === 0">
            <img v-if='showsmallimg1' style='width: 150px' :src='record.right' @click='previewImage1(record.right)' />
            <img v-if='showbigimg1' style='width: 550px' :src='record.right' @click='closepreviewImage1(record.right)'>
          </div>
          <div v-if="record.left.indexOf('人脸照片') === 0">
            <img v-if='showsmallimg2' style='width: 150px' :src='record.right' @click='previewImage2(record.right)' />
            <img v-if='showbigimg2' style='width: 550px' :src='record.right' @click='closepreviewImage2(record.right)'>
          </div>
          <div v-if="record.left !=='身份证反面' && record.left!=='身份证正面'&& record.left!=='人脸照片'">
            {{ record.right }}
          </div>
        </template>
      </a-table>

      <a-modal v-model='visdialog' title='修改订单逾期天数' @ok='handleOk' width='1000px'>
        <a-form :loading='loading' :form='orderInfoForm' :label-col='{ span: 5 }' :wrapper-col='{ span: 18 }'>
          <a-form-item :label="'订单ID'">
            <a-input disabled='disabled' v-model='orderInfoForm.id'></a-input>
          </a-form-item>
          <a-form-item :label="'逾期天数'">
            <a-input v-model='orderInfoForm.overdueDays'></a-input>
          </a-form-item>
        </a-form>
      </a-modal>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getCustOrderDetail } from '@/webpublicapi/customer'
import { updateOverdueDaysById, getApplist } from '@/webpublicapi/order'
import config from '@/config/common.json'

const I18N_KEY = 'order.'

export default {
  name: 'CustExtOrder',
  data() {
    return {
      showsmallimg: true,
      showbigimg: false,
      showsmallimg1: true,
      showbigimg1: false,
      showsmallimg2: true,
      showbigimg2: false,
      selectedList: {},
      visdialog: false,
      I18N_KEY,
      // 分页参数
      dataSource: [],
      // 查询条件
      queryParam: {
        'mobileNo': undefined,
        'appSsid': undefined
      },
      orderInfoForm: {
        id: undefined,
        overdueDays: undefined
      },
      loading: false,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '列名',
          align: 'left',
          width: '150px',
          dataIndex: 'left',
          scopedSlots: { customRender: 'noticeTitle1' }

        },
        {
          title: '值',
          align: 'left',
          width: '150px',
          dataIndex: 'right',
          scopedSlots: { customRender: 'noticeTitle2' }

        }
      ]
    }
  },
  created() {
    getApplist().then(res => {
      if (res.code === 1000) {
        this.selectedList = res.data
        console.log('selectedList', this.selectedList)
      } else {

      }
    })
    // this.loadData()
  },
  methods: {
    previewImage(e) {
      this.showbigimg = true
      this.showsmallimg = false
    },
    previewImage1(e) {
      this.showbigimg1 = true
      this.showsmallimg1 = false
    },
    previewImage2(e) {
      this.showbigimg2 = true
      this.showsmallimg2 = false
    },
    closepreviewImage(e) {
      this.showbigimg = false
      this.showsmallimg = true
    },
    closepreviewImage1(e) {
      this.showbigimg1 = false
      this.showsmallimg1= true
    },
    closepreviewImage2(e) {
      this.showbigimg2 = false
      this.showsmallimg2 = true
    },
    panhaoChange(e) {
      console.log('盘号变了！！！！', e)
    },
    searchQuery() {
      this.loadData()
    },
    loadData() {
      this.loading = true
      var appSsid = this.queryParam.appSsid
      var mobileNo = this.queryParam.mobileNo
      getCustOrderDetail(appSsid, mobileNo).then((res) => {
        console.log('res是啥！！！',res)
        if (res.code === 1000) {
          this.dataSource = []
          for (let i in res.data) {
            if (i.indexOf('time') != -1 || i.indexOf('birthday') != -1) {
              i === 'cust_ext_info.house_time' ? '' : res.data[i] = this.transformTime(res.data[i])
            }
            if (i == 'order_info.id') {
              this.orderInfoForm.id = res.data[i]
            }
            if (i == 'order_info.overdue_days') {
              this.orderInfoForm.overdueDays = res.data[i]
            }
            let dictElement = config.dict[i]
            if (process.env.VUE_APP_CONFIG == 'jn') {
              dictElement = config.jn_dict[i]
            } else if (process.env.VUE_APP_CONFIG == 'zaf') {
              dictElement = config.dict_zaf[i]
            }
            if (dictElement) {
              res.data[i] = res.data[i] + (/^\d+$/.test(res.data[i]) ? '(参数正确)' : '(参数错误)')
            }

            let trans = config.trans[i]
            if (process.env.VUE_APP_CONFIG == 'zaf') {
              trans = config.trans_zaf[i]
            }

            if (trans) {
              let obj = {
                left: trans,
                right: res.data[i]
              }
              this.dataSource.push(obj)
            }
          }
        } else {
          this.dataSource = []
          this.$message.error('手机号和盘号都是必填！')
        }
        this.loading = false
        console.log('dataSource-->', this.dataSource)
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.appSsid = ''
      that.queryParam.mobileNo = ''
      this.orderInfoForm.id = undefined,
        this.orderInfoForm.overdueDays = undefined,
        this.dataSource = []
    },
    handleDetail() {
      console.log("this.orderInfoForm",this.orderInfoForm)
      console.log("this.orderInfoForm.id",this.orderInfoForm.id)
      if (this.orderInfoForm.id == undefined) {
        this.$message.error('请先查询订单！')
      } else {
        this.visdialog = true
        this.loading = false
      }
    },
    handleOk() {
      updateOverdueDaysById(this.orderInfoForm.id, this.orderInfoForm.overdueDays).then(res => {
        if (res.code === 1000) {
          this.$message.success(this.$t('success'))
          this.orderInfoForm = {
            id: undefined,
            overdueDays: undefined
          }
          this.visdialog = false
          this.loadData()
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
